import React from 'react';

// Use relative URL for API calls in Docker, fallback to localhost for local dev
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

function ExportButton({ exportType = 'summary', days = 7, label = null }) {
  const handleExport = () => {
    const url = `${API_BASE_URL}/api/export/csv?export_type=${exportType}&days=${days}`;
    window.open(url, '_blank');
  };

  const displayLabel = label || exportType.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase());

  return (
    <button onClick={handleExport} className="export-button" title={`Export ${displayLabel} as CSV`}>
      📥 Export {displayLabel}
    </button>
  );
}

export default ExportButton;
